define([
    "./nlgPortletModule",
    "./nlgPortletDirective",
    "./nlgPortletTitle",
    "./nlgPortletBody",
    "./nlgPortletGroup"
], function () {
});
